import { Observable, of, map, catchError } from 'rxjs';
import { ComponentPermissionService, PermissionFunction } from '../component-permission.service';

export function isEventInstructor(service: ComponentPermissionService): PermissionFunction {
  return {
    name: 'Is Event Instructor',
    description: 'Check if user is specifically an instructor for the given event',
    requiresContext: true,
    execute: (context?: any) => {
      
      // If no event ID provided, deny access
      if (!context?.eventId) {
        return of(false);
      }

      // Get current user
      const currentUser = service.authService.getCurrentUser();
      if (!currentUser) {
        return of(false);
      }

      // Check if user is an instructor for this specific event
      const eventId = context.eventId;
      return service.http.get(`${service.apiUrl}/events/${eventId}/instructors`).pipe(
        map((instructors: any) => {
          
          if (Array.isArray(instructors)) {
            const isInstructor = instructors.some(instructor => 
              instructor.id === currentUser.id || 
              instructor.user_id === currentUser.id ||
              instructor.uuid === currentUser.uuid
            );
            return isInstructor;
          }
          
          return false;
        }),
        catchError(error => {
          console.error('[isEventInstructor] Error checking event instructors:', error);
          return of(false);
        })
      );
    }
  };
} 